/* BURDLIFE coming-soon gate. Ported from coordination-2026-10-22/revision-007/coming-soon-mock (v9).
   Image URLs, product links and button copy come from data attributes written by Liquid. */
(function(){
  var conn=navigator.connection||{};
  var lite=!!(conn.saveData||(navigator.hardwareConcurrency&&navigator.hardwareConcurrency<=2)||/lite=1/.test(location.search));
  var reduced=!!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches);
  var params;try{params=new URLSearchParams(location.search)}catch(e){params={get:function(){return null}}}

  function initChains(root){
    if(lite)root.setAttribute('data-lite','');
    // glints on the first chain: static placement, CSS pulse
    var path=root.querySelector('[data-chain-path]'),g=root.querySelector('[data-glints]'),ns='http://www.w3.org/2000/svg';
    if(path&&g&&path.getTotalLength){var L0=path.getTotalLength();
      for(var i=0;i<14;i++){var p=path.getPointAtLength(L0*(i+.5)/14),e=document.createElementNS(ns,'ellipse');
        e.setAttribute('cx',p.x);e.setAttribute('cy',p.y);e.setAttribute('rx',3.2);e.setAttribute('ry',1.6);
        e.style.animationDelay=(-(i*0.64)).toFixed(2)+'s';g.appendChild(e)}}

    // layered chains: photo tiles repeated along offsets of the first chain's wave
    var cv=root.querySelector('[data-strands]'),base=root.querySelector('.burdlife-coming-soon__top'),ds=root.dataset;
    if(!(cv&&cv.getContext&&base&&base.getScreenCTM&&ds.tileDainty&&ds.tileBold&&ds.tileRolo&&ds.tileCap))return;
    var ctx=cv.getContext('2d'),svg=base.ownerSVGElement,phone=matchMedia('(max-width:749px)');
    var STRANDS=[{src:ds.tileDainty,h:15,sparkle:true},{cuff:true,h:5},{src:ds.tileBold,h:24,sparkle:true},{src:ds.tileRolo,h:17}];
    var cap=new Image(),pending=1,t0=performance.now(),pts=[],nrm=[],arc=[],W=0,H=0,scale=1,gap=76,raf=0;
    function load(img,src){pending++;img.onload=img.onerror=function(){if(--pending===0)start()};img.src=src}
    STRANDS.forEach(function(s){if(s.src){s.img=new Image();load(s.img,s.src)}});
    load(cap,ds.tileCap);pending--;

    function measure(){
      var r=root.getBoundingClientRect(),dpr=Math.min(window.devicePixelRatio||1,2);
      W=r.width;H=r.height;cv.width=Math.round(W*dpr);cv.height=Math.round(H*dpr);ctx.setTransform(dpr,0,0,dpr,0,0);
      scale=phone.matches?.62:1;gap=phone.matches?24:38; // about 1 cm apart on desktop
      var m=base.getScreenCTM(),L=base.getTotalLength(),n=Math.ceil(L/3),sp=svg.createSVGPoint();
      pts=[];for(var i=0;i<=n;i++){var q=base.getPointAtLength(L*i/n);sp.x=q.x;sp.y=q.y;var s=sp.matrixTransform(m);pts.push([s.x-r.left,s.y-r.top])}
      nrm=[];arc=[0];
      for(i=0;i<pts.length;i++){var a=pts[Math.max(0,i-1)],b=pts[Math.min(pts.length-1,i+1)],dx=b[0]-a[0],dy=b[1]-a[1],d=Math.hypot(dx,dy)||1;nrm.push([-dy/d,dx/d]);
        if(i)arc.push(arc[i-1]+Math.hypot(pts[i][0]-pts[i-1][0],pts[i][1]-pts[i-1][1]))}
    }
    function line(k,t,still){ // offset polyline with a travelling sway
      var off=(k+1)*gap,amp=still?0:4*scale,out=[],len=[0];
      for(var i=0;i<pts.length;i++){var u=off+amp*Math.sin(arc[i]/420*6.283-t*1.2+k*.7);
        out.push([pts[i][0],pts[i][1]+u]); // same wave, shifted straight down
        if(i)len.push(len[i-1]+Math.hypot(out[i][0]-out[i-1][0],out[i][1]-out[i-1][1]))}
      return {p:out,len:len,total:len[len.length-1]};
    }
    function at(l,s,j){ // point and angle at arc length s, walking forward from index j
      while(j<l.len.length-2&&l.len[j+1]<s)j++;
      var a=l.p[j],b=l.p[j+1],f=(s-l.len[j])/((l.len[j+1]-l.len[j])||1);
      return {x:a[0]+(b[0]-a[0])*f,y:a[1]+(b[1]-a[1])*f,r:Math.atan2(b[1]-a[1],b[0]-a[0]),j:j};
    }
    function ease(x){x=Math.min(1,Math.max(0,x));return 1-Math.pow(1-x,3)}
    function frame(now){
      var still=reduced||lite,t=still?1e4:(now-t0)/1000;
      ctx.clearRect(0,0,W,H);
      STRANDS.forEach(function(st,k){
        var l=line(k,t,still),shown=l.total*ease((t-.5-.45*k)/5.5);if(shown<=0)return;
        var h=st.h*scale,j=0,q;
        if(st.cuff){ // slim open cuff: gold wire with a bezel diamond on each end, gliding along the wave
          var sa=l.total*(.08+(still?0:.04*Math.sin(t*.25))),sb=Math.min(shown,sa+l.total*.8);if(sb<=sa)return;
          [[5.5*scale,'#7a5a1c',0],[3.6*scale,'#d8b25c',0],[1.2*scale,'rgba(255,241,194,.9)',-.9*scale]].forEach(function(s){
            ctx.beginPath();j=0;for(var x=sa;x<=sb;x+=4){q=at(l,x,j);j=q.j;ctx.lineTo(q.x,q.y+s[2])}
            ctx.lineWidth=s[0];ctx.strokeStyle=s[1];ctx.lineCap='round';ctx.stroke()});
          var cs=18*scale;if(cap.naturalWidth)[sa].concat(sb>=sa+l.total*.8-1?[sb]:[]).forEach(function(x){q=at(l,x,0);ctx.drawImage(cap,q.x-cs/2,q.y-cs/2,cs,cs)});
          return;
        }
        var img=st.img;if(!img||!img.naturalWidth)return;
        var w=img.naturalWidth*h/img.naturalHeight,phase=still?0:t*15,first=(phase%w)-w;
        ctx.save();ctx.shadowColor='rgba(40,44,24,.3)';ctx.shadowBlur=4*scale;ctx.shadowOffsetY=2*scale;
        for(var s=first;s<shown;s+=w){
          if(s+w<0)continue;q=at(l,Math.max(0,s+w/2),j);j=q.j;
          ctx.setTransform(ctx.getTransform().a,0,0,ctx.getTransform().d,0,0);
          ctx.translate(q.x,q.y);ctx.rotate(q.r);ctx.drawImage(img,-w/2,-h/2,w,h);
          if(st.sparkle&&!still){var idx=Math.round((s-phase)/w);
            if(((idx%9)+9)%9===(k*4)%9){var a=Math.pow(Math.max(0,Math.sin(t*1.7+idx*1.3)),12);
              if(a>.02){ctx.shadowBlur=0;ctx.globalAlpha=a;ctx.strokeStyle='#fff';ctx.lineWidth=1;var z=h*.45;
                ctx.beginPath();ctx.moveTo(-z,0);ctx.lineTo(z,0);ctx.moveTo(0,-z);ctx.lineTo(0,z);ctx.stroke();
                ctx.globalAlpha=1;ctx.shadowBlur=4*scale}}}
          var dpr=cv.width/W;ctx.setTransform(dpr,0,0,dpr,0,0);
        }
        ctx.restore();
      });
      if(!still&&!document.hidden)raf=requestAnimationFrame(frame);
    }
    function start(){root.setAttribute('data-strands-live','');measure();cancelAnimationFrame(raf);raf=requestAnimationFrame(frame)}
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(start,120)});
    document.addEventListener('visibilitychange',function(){if(!document.hidden)start()});
  }

  // booking: Houston and Nashville open the Servicify product pages; a store without a product shows its closed label
  function initBooking(booking){
    var btn=booking.querySelector('[data-submit]'),helper=booking.querySelector('[data-helper]'),mapEl=booking.querySelector('[data-booking-map]');
    if(!btn)return;
    var map={};try{map=JSON.parse(mapEl.textContent)||{}}catch(e){}
    var d=btn.dataset,fixed=booking.getAttribute('data-fixed-service');
    function urlFor(sv,st){return sv&&st&&map[sv]&&map[sv][st]?map[sv][st]:''}
    function sync(){
      var stIn=booking.querySelector('input[name=store]:checked'),svIn=booking.querySelector('input[name=service]:checked');
      var st=stIn&&stIn.value,sv=fixed||(svIn&&svIn.value),url=urlFor(sv,st);
      var anyForStore=false;if(st)for(var k in map){if(map[k]&&map[k][st])anyForStore=true}
      if(helper)helper.textContent='';btn.removeAttribute('href');btn.setAttribute('aria-disabled','true');
      if(url){btn.textContent=d.labelBook;btn.setAttribute('aria-disabled','false');btn.href=url}
      else if(st&&stIn.getAttribute('data-closed-label')&&(sv||!anyForStore)){
        btn.textContent=stIn.getAttribute('data-closed-label');if(helper)helper.textContent=stIn.getAttribute('data-closed-helper')||''}
      else btn.textContent=st?(d.labelService||d.labelDefault):sv?(d.labelStore||d.labelDefault):d.labelDefault;
    }
    // picking a store with no service yet selects Ear piercing, so "Book now" shows at once
    booking.addEventListener('change',function(e){
      if(!fixed&&e.target&&e.target.name==='store'&&!booking.querySelector('input[name=service]:checked')){
        var first=booking.querySelector('input[name=service][value=piercing]')||booking.querySelector('input[name=service]:not(:disabled)');if(first)first.checked=true}
      sync()});
    sync();
    btn.addEventListener('click',function(e){if(btn.getAttribute('aria-disabled')==='true')e.preventDefault()});
  }

  // events enquiry: preselect the event type (and city) from ?type=
  function initEvents(form){
    var type=params.get('type');if(!type)return;
    var sel=form.querySelector('[data-event-type]'),opt=sel&&sel.querySelector('option[data-key="'+type.replace(/[^a-z0-9-]/gi,'')+'"]');
    if(!opt)return;sel.value=opt.value;
    var city=opt.getAttribute('data-city'),cs=form.querySelector('[data-event-city]');
    if(city&&cs){var co=cs.querySelector('option[data-key="'+city+'"]');if(co)cs.value=co.value}
  }

  // ---------- RSVP pop-up: calendar links (Google, .ics, Outlook.com) ----------
  function pad(n){return (n<10?'0':'')+n}
  function zoneParts(ms,tz){ // wall-clock parts of instant ms in time zone tz
    var o={};new Intl.DateTimeFormat('en-US',{timeZone:tz,hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit'})
      .formatToParts(new Date(ms)).forEach(function(p){o[p.type]=+p.value});if(o.hour===24)o.hour=0;return o}
  function zonedToUtc(y,mo,d,h,mi,tz){ // wall time in tz -> UTC ms (two passes for DST edges)
    var guess=Date.UTC(y,mo-1,d,h,mi),utc=guess;
    for(var i=0;i<2;i++){var p=zoneParts(utc,tz);utc=guess-(Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second)-utc)}return utc}
  function stamp(p){return p.year+pad(p.month)+pad(p.day)+'T'+pad(p.hour)+pad(p.minute)+pad(p.second||0)}
  function utcStamp(ms){var d=new Date(ms);return d.getUTCFullYear()+pad(d.getUTCMonth()+1)+pad(d.getUTCDate())+'T'+pad(d.getUTCHours())+pad(d.getUTCMinutes())+pad(d.getUTCSeconds())+'Z'}
  function icsText(t){return String(t||'').replace(/\\/g,'\\\\').replace(/;/g,'\\;').replace(/,/g,'\\,').replace(/\r?\n/g,'\\n')}
  var NY_VTIMEZONE=['BEGIN:VTIMEZONE','TZID:America/New_York','BEGIN:DAYLIGHT','TZOFFSETFROM:-0500','TZOFFSETTO:-0400','TZNAME:EDT','DTSTART:19700308T020000','RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU','END:DAYLIGHT',
    'BEGIN:STANDARD','TZOFFSETFROM:-0400','TZOFFSETTO:-0500','TZNAME:EST','DTSTART:19701101T020000','RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU','END:STANDARD','END:VTIMEZONE'];
  function initCalendar(dlg){
    var ds=dlg.dataset,tz=ds.calTimezone||'America/New_York';
    var dm=/^(\d{4})-(\d{2})-(\d{2})$/.exec(ds.calDate||''),tm=/^(\d{1,2}):(\d{2})$/.exec(ds.calTime||'');
    if(!dm||!tm)return;
    var startMs,endMs,sp,ep;
    try{startMs=zonedToUtc(+dm[1],+dm[2],+dm[3],+tm[1],+tm[2],tz);endMs=startMs+(parseInt(ds.calDuration,10)||120)*60000;sp=zoneParts(startMs,tz);ep=zoneParts(endMs,tz)}catch(e){return}
    var title=ds.calTitle||'',loc=ds.calLocation||'',desc=ds.calDescription||'';
    var g='https://calendar.google.com/calendar/render?action=TEMPLATE&text='+encodeURIComponent(title)+'&dates='+stamp(sp)+'/'+stamp(ep)+'&ctz='+encodeURIComponent(tz)+'&location='+encodeURIComponent(loc)+'&details='+encodeURIComponent(desc);
    var o='https://outlook.live.com/calendar/0/action/compose?rru=addevent&subject='+encodeURIComponent(title)+'&startdt='+new Date(startMs).toISOString()+'&enddt='+new Date(endMs).toISOString()+'&location='+encodeURIComponent(loc)+'&body='+encodeURIComponent(desc);
    var ics=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//BURDLIFE//Coming soon//EN','CALSCALE:GREGORIAN','METHOD:PUBLISH'].concat(tz==='America/New_York'?NY_VTIMEZONE:[]).concat([
      'BEGIN:VEVENT','UID:burdlife-'+stamp(sp)+'-medley@burdlife.com','DTSTAMP:'+utcStamp(Date.now()),
      'DTSTART;TZID='+tz+':'+stamp(sp),'DTEND;TZID='+tz+':'+stamp(ep),
      'SUMMARY:'+icsText(title),'LOCATION:'+icsText(loc),'DESCRIPTION:'+icsText(desc),'END:VEVENT','END:VCALENDAR']).join('\r\n')+'\r\n'; // RFC 5545: every line ends with CRLF
    var links={google:g,outlook:o,ics:'data:text/calendar;charset=utf-8,'+encodeURIComponent(ics)};
    Array.prototype.forEach.call(dlg.querySelectorAll('[data-cal]'),function(a){var u=links[a.getAttribute('data-cal')];if(u)a.href=u});
  }

  // ---------- which customer form the reload came from ----------
  // Shopify reloads with #<form id> after a customer form post. The hash can be lost (captcha challenge,
  // some redirects), so the form id is also kept in sessionStorage on submit and used once on the next load.
  var FORM_KEY='burdlifeFormPosted';
  function storage(){try{return window.sessionStorage}catch(e){return null}}
  function postedFormId(){
    var ss=storage(),saved=null;
    if(ss){try{saved=ss.getItem(FORM_KEY);ss.removeItem(FORM_KEY)}catch(e){}}
    var hash=location.hash.slice(1);if(hash)return hash;
    if(saved&&/^[A-Za-z0-9_-]+$/.test(saved)&&document.querySelector('[data-form-status="'+saved+'"]'))return saved;
    return '';
  }
  function rememberFormSubmit(){
    Array.prototype.forEach.call(document.querySelectorAll('form#BurdlifeRsvpForm,form#BurdlifeComingSoonSignupForm'),function(f){
      f.addEventListener('submit',function(){var ss=storage();if(ss){try{ss.setItem(FORM_KEY,f.id)}catch(e){}}});
    });
  }

  // ---------- RSVP pop-up: open, close, success state ----------
  function initRsvp(dlg,posted){
    initCalendar(dlg);
    var canModal=typeof dlg.showModal==='function',opener=null;
    function open(trigger){if(!canModal)return false;opener=trigger||null;if(!dlg.open)dlg.showModal();var c=dlg.querySelector('[data-rsvp-close]');if(c)c.focus();return true}
    Array.prototype.forEach.call(document.querySelectorAll('[data-rsvp-open]'),function(a){
      a.addEventListener('click',function(e){if(open(a))e.preventDefault()})}); // no dialog support: the link opens the events page
    Array.prototype.forEach.call(dlg.querySelectorAll('[data-rsvp-close]'),function(b){b.addEventListener('click',function(){dlg.close()})});
    dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close()}); // click on the backdrop
    dlg.addEventListener('close',function(){if(opener&&opener.focus)opener.focus()});
    // after the customer form posts, Shopify reloads with #BurdlifeRsvpForm: reopen in the "on the list" state
    var mine=posted==='BurdlifeRsvpForm';
    if(mine&&dlg.querySelector('[data-form-ok]')){dlg.classList.add('is-done');var ok=dlg.querySelector('[data-rsvp-success]');if(ok)ok.hidden=false;open(null)}
    else if(mine&&dlg.querySelector('[data-form-status]'))open(null);
  }

  // two customer forms share one page: show each form's message only when the reload came from that form
  function scopeFormStatus(hash){
    if(!hash)return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-form-status]'),function(el){
      if(el.getAttribute('data-form-status')!==hash){el.hidden=true;el.removeAttribute('data-signup-status')}});
  }

  function init(){
    var posted=postedFormId();
    scopeFormStatus(posted);
    rememberFormSubmit();
    Array.prototype.forEach.call(document.querySelectorAll('[data-burdlife-rsvp]'),function(dlg){initRsvp(dlg,posted)});
    Array.prototype.forEach.call(document.querySelectorAll('[data-burdlife-coming-soon]'),initChains);
    Array.prototype.forEach.call(document.querySelectorAll('[data-burdlife-booking]'),initBooking);
    Array.prototype.forEach.call(document.querySelectorAll('[data-burdlife-events-form]'),initEvents);
    // no timed autofocus on the sign-up email: focusing the form loads hCaptcha (~930 KB) for every visitor
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
